import { ArrowUp } from "lucide-react";

export default function BackToTop() {
  return (
    <div className="flex justify-end px-6 pb-4 lg:px-12">
      <button
        type="button"
        data-testid="back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="group inline-flex items-center gap-3 border border-white/15 px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.3em] text-[#9EA3B0] transition-colors duration-300 hover:border-umber hover:text-umber"
      >
        Top
        <ArrowUp size={12} className="transition-transform duration-500 group-hover:-translate-y-1" />
      </button>
    </div>
  );
}
